import { Swiper } from './swiper-BS-F1fmK.js';
import { N as Navigation } from './navigation-yBYgHuIg.js';
import { f as freeMode } from './free-mode-B49qs38f.js';
import './utils-DfPPEfgu.js';
import './create-element-if-not-defined-BQEJuiIf.js';

class FeaturedCollection extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.tabs.forEach((tab) => tab.addEventListener('click', () => this.switchTab(tab)));

    const activePanel = this.querySelector('[role="tabpanel"][aria-hidden="false"]');
    if (activePanel) this.initSwiper(activePanel);

    this.initTabsSwiper();
  }

  initTabsSwiper() {
    const tabsSwiperEl = this.querySelector('.tabs-swiper');
    if (!tabsSwiperEl || tabsSwiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(tabsSwiperEl, {
      modules: [freeMode],
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
    });
  }

  initSwiper(panel) {
    const swiperEl = panel.querySelector('.swiper');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        prevEl: panel.querySelector('.swiper-prev'),
        nextEl: panel.querySelector('.swiper-next'),
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
        },
      },
    });
  }

  switchTab(selectedTab) {
    const targetId = selectedTab.getAttribute('aria-controls');
    const targetPanel = this.querySelector(`#${targetId}`);

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', isSelected);
      tab.classList.toggle('button--primary', isSelected);
      tab.classList.toggle('button--secondary', !isSelected);
    });

    this.panels.forEach((panel) => {
      const isHidden = panel !== targetPanel;
      panel.setAttribute('aria-hidden', isHidden);
      if (!isHidden) this.initSwiper(panel);
    });
  }
}

if (!customElements.get('featured-collection'))
  customElements.define('featured-collection', FeaturedCollection);
